import { navigate } from 'gatsby'
import React from 'react'
import { activitySEO } from '../../../constants/activity-constants'
import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import Show from '../../../utils/show'

import './modal-endgame.scss'

const LOCALE =
  ['es-AR', 'es-CL', 'es-PE', 'es-PY', 'es-UY'].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY'

const userInfo = getUserInfo()
const handleClickLink = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_Enlaces_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

const handleModal = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    action: 'view',
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

const handleClick = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

export default function ModalEndGame(props) {
  const { totalPoints, handleSuccess, win = true } = props

  const goTop = () => {
    //window.location.href = `${activitySEO.url}/top`
    navigate('/top')
  }

  if (win) {
    handleModal('Wowwww ¡Lo lograste!')
  } else {
    handleModal('UUUUUUPS! Ya se te acabo el tiempo')
  }

  return (
    <div className="modal-endgame">
      <div className="modal-endgame-container">
        <div className="wrapper-star">
          <h2 className="wrapper-star__title">
            <span className="">{win ? 'Wowwww' : '¡UUUUUUPS!'}</span>
          </h2>
          <div className="wrapper-star__body">
            <p className="wrapper-star__body__textBody">
              {win ? '¡Lo lograste!' : 'Ya se te acabó el tiempo'} <br />
              <br />
              <span className="wrapper-star__body__textBody__textPuntos">
                {win
                  ? 'Ganaste ' + totalPoints + ' puntos.'
                  : '¡Lograste! ' + totalPoints + ' puntos.'}
              </span>
              <br />
              <br />
              {win ? (
                <>
                  <Show valid={!italatam && LOCALE !=='es-UY'}>
                    ¿Quieres ver si estás entre los mejores puntajes? Haz clic{' '}
                    <a
                      onClick={() => {
                        goTop()
                        handleClickLink('aquí')
                      }}
                      className="wrapper-star__body__textBody__textPuntos__link"
                    >
                      aquí
                    </a>
                  </Show>
                  <Show valid={italatam && LOCALE !=='es-UY'}>
                    ¿Querés ver si estás entre los mejores puntajes? Haz acá{' '}
                    <a
                      onClick={() => {
                        goTop()
                        handleClickLink('aquí')
                      }}
                      className="wrapper-star__body__textBody__textPuntos__link"
                    >
                      aquí
                    </a>
                  </Show>
                </>
              ) : (
                <>
                  <Show valid={!italatam}>Vuelve a jugar, ¡no te rindas!</Show>
                  <Show valid={italatam}>Volvé a jugar, ¡no te rindás!</Show>
                </>
              )}
            </p>
            <button
              className="btn-primary f-concentrate-modal-endgame-btn"
              onClick={() => {
                handleSuccess()
                handleClick('Volver a jugar')
              }}
            >
              Volver a jugar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
